import Swal from 'sweetalert2';

document.addEventListener('DOMContentLoaded', () => {
    initModalPerpanjang();
});

window.closeModalPerpanjang = closeModalPerpanjang;

export function batalOrder(orderId) {
    // Swal konfirmasi otomatis
    Swal.fire({
        title: "Apakah Anda yakin?",
        text: "Order ini akan dibatalkan!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, batalkan!",
        cancelButtonText: "Batal",
        allowOutsideClick: false, // supaya tidak bisa klik luar
        allowEscapeKey: false
    }).then(async (result) => {
        if (!result.isConfirmed) return;

        try {
            const response = await fetch(`/ReportController/${orderId}/cancelOrder`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
                }
            });

            const data = await response.json();

            if (data.success) {
                Swal.fire({
                    title: "Berhasil!",
                    text: "Order berhasil dibatalkan.",
                    icon: "success",
                    timer: 1500,
                    showConfirmButton: false
                }).then(() => {
                    window.location.reload(); // bisa diganti update tabel via JS
                });
            } else {
                Swal.fire({
                    title: "Gagal",
                    text: data.message || "Gagal membatalkan order.",
                    icon: "error",
                    confirmButtonText: "OK"
                });
            }
        } catch (error) {
            console.error("Error:", error);
            Swal.fire({
                title: "Error",
                text: "Terjadi kesalahan, coba lagi.",
                icon: "error",
                confirmButtonText: "OK"
            });
        }
    });
}

export function initModalPerpanjang() {
    const modal = document.getElementById('modalPerpanjangKontrakBulanan');
    const content = document.getElementById('modalContentPerpanjangKontrakBulanan');

    if (!modal || !content) return;

    window.addEventListener('open-perpanjang', () => {
        modal.classList.remove('hidden');
        document.body.classList.add('overflow-hidden');

        requestAnimationFrame(() => {
            content.classList.remove('scale-95', 'opacity-0');
            content.classList.add('scale-100', 'opacity-100');
        });
    });
}

export function closeModalPerpanjang() {
    const modal = document.getElementById('modalPerpanjangKontrakBulanan');
    const content = document.getElementById('modalContentPerpanjangKontrakBulanan');

    if (!modal || !content) return;

    content.classList.remove('scale-100', 'opacity-100');
    content.classList.add('scale-95', 'opacity-0');

    setTimeout(() => {
        modal.classList.add('hidden');
        document.body.classList.remove('overflow-hidden');
    }, 300);
}

const handleSimpanGaji = async (orderId, driverId, nominal, inputPrefix) => {

    // Bersihkan format rupiah (hapus titik & koma)
    const cleanNominal = Number(String(nominal).replace(/\D/g, ''));

    if (!cleanNominal || cleanNominal <= 0) {
        Swal.fire('Perhatian', 'Masukkan nominal gaji dengan benar!', 'warning');
        return;
    }

    const confirm = await Swal.fire({
        title: 'Konfirmasi Simpan',
        text: `Simpan gaji Rp ${cleanNominal.toLocaleString('id-ID')} untuk Order ID: ${orderId}?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#059669',
        cancelButtonColor: '#64748b',
        confirmButtonText: 'Ya, Simpan!',
        cancelButtonText: 'Batal'
    });

    if (!confirm.isConfirmed) return;

    Swal.fire({
        title: 'Sedang memproses...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => Swal.showLoading()
    });

    try {
        const response = await fetch('/report/driver-salary', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                order_id: orderId,
                driver_id: driverId,
                nominal: cleanNominal
            })
        });

        // 🔥 Handle non-json response
        let result = {};
        try {
            result = await response.json();
        } catch (e) {
            result.message = 'Response tidak valid dari server';
        }

        if (!response.ok) {
            throw new Error(result.message || 'Terjadi kesalahan sistem');
        }

        Swal.fire({
            title: 'Berhasil!',
            text: result.message || 'Gaji berhasil disimpan',
            icon: 'success',
            timer: 2000,
            timerProgressBar: true,
            showConfirmButton: false
        });

        // 🔥 Reset input
        const inputEl = document.getElementById(`${inputPrefix}_${orderId}`);
        if (inputEl) inputEl.value = '';

    } catch (error) {
        console.error('Error:', error);

        Swal.fire({
            title: 'Gagal',
            text: error.message || 'Gagal menghubungi server.',
            icon: 'error',
            confirmButtonColor: '#ef4444'
        });
    }
};

window.simpanGajiDriverIn = (orderId, driverId, nominal) =>
    handleSimpanGaji(orderId, driverId, nominal, 'nominal_in');

window.simpanGajiDriverOut = (orderId, driverId, nominal) =>
    handleSimpanGaji(orderId, driverId, nominal, 'nominal_out');

function formatRupiah(angka) {
    return 'Rp ' + Number(angka || 0).toLocaleString('id-ID');
}

window.openModalPembayaran = async function (orderId, orderCode, type = 'in') {

    const suffix = type === 'out' ? '_out' : '_in';

    document.getElementById(`order_code${suffix}`).value = orderCode;

    const res = await fetch(`/report/payment/${orderId}`);
    const result = await res.json();

    if (!result.success) {
        Swal.fire("Error", result.message, "error");
        return;
    }

    const data = result.data;

    document.getElementById(`order_payment_id${suffix}`).value = data.order_payment_id;
    document.getElementById(`nota_id${suffix}`).value = data.nota_id;
    document.getElementById(`payment_method${suffix}`).value = data.payment_method;

    const summaryRes = await fetch(`/report/payment-summary/${orderId}`);
    const summary = await summaryRes.json();

    document.getElementById(`total_order${suffix}`).innerText = formatRupiah(summary.total_order);
    document.getElementById(`total_paid${suffix}`).innerText = formatRupiah(summary.total_paid);
    document.getElementById(`sisa${suffix}`).innerText = formatRupiah(summary.sisa);

    document.getElementById(`modalPembayaran${suffix}`).classList.remove("hidden");
}

window.closeModalPembayaran = function(type = 'in') {
    const suffix = type === 'out' ? '_out' : '_in';
    document.getElementById(`modalPembayaran${suffix}`).classList.add("hidden");
}

const bindForm = (type = 'in') => {
    const suffix = type === 'out' ? '_out' : '_in';
    const form = document.getElementById(`formPembayaran${suffix}`);

    if (!form) return;

    form.addEventListener("submit", async function (e) {
        e.preventDefault();

        const formData = new FormData();

        formData.append("order_payment_id", document.getElementById(`order_payment_id${suffix}`).value);
        formData.append("nota_id", document.getElementById(`nota_id${suffix}`).value);
        formData.append("amount", document.getElementById(`amount${suffix}`).value);
        formData.append("image_path", document.getElementById(`image_path${suffix}`).files[0]);

        const res = await fetch("/report/payment/store", {
            method: "POST",
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
            },
            body: formData
        });

        const result = await res.json();

        if (result.success) {
            Swal.fire("Berhasil", result.message, "success");
            closeModalPembayaran(type);
            window.location.reload();
        } else {
            Swal.fire("Error", result.message, "error");
        }
    });
};

// panggil dua-duanya
bindForm('in');
bindForm('out');

const bindImagePreview = (type = 'in') => {
    const suffix = type === 'out' ? '_out' : '_in';

    const input = document.getElementById(`image_path${suffix}`);
    const preview = document.getElementById(`previewImage${suffix}`);
    const placeholder = document.getElementById(`uploadPlaceholder${suffix}`);

    if (!input) return;

    input.addEventListener("change", function (event) {
        const file = event.target.files[0];

        if (file && preview && placeholder) {
            const reader = new FileReader();

            reader.onload = function (e) {
                preview.src = e.target.result;
                preview.classList.remove("hidden");
                placeholder.classList.add("hidden");
            };

            reader.readAsDataURL(file);
        }
    });
};

// panggil
bindImagePreview('in');
bindImagePreview('out');

window.toggleHistory = function(orderId) {

    const el = document.getElementById(`history_${orderId}`)

    if (!el) return

    if (el.classList.contains("hidden")) {

        el.classList.remove("hidden")

        // 🔥 Load data saat dibuka
        loadPaymentHistory(orderId)

    } else {

        el.classList.add("hidden")

    }

}

// Fungsi untuk membuka Modal History
window.openModalHistory = async function(orderId, orderCode, type = 'in') {
    const suffix = type === 'out' ? '_out' : '_in';

    const modal = document.getElementById(`modalHistory${suffix}`);
    const content = document.getElementById(`historyContent${suffix}`);
    const labelCode = document.getElementById(`hist_order_code${suffix}`);

    labelCode.innerText = `#${orderCode}`;
    content.innerHTML = `<div class="text-center py-4"><i class="fas fa-spinner fa-spin text-blue-500"></i> Loading...</div>`;
    modal.classList.remove("hidden");

    try {
        const res = await fetch(`/report/payment-history/${orderId}`);
        const result = await res.json();

        if (!result.success || result.data.length === 0) {
            content.innerHTML = `
                <div class="text-center py-8">
                    <img src="https://illustrations.popsy.co/gray/no-data.svg" class="w-32 mx-auto mb-2">
                    <p class="text-slate-400 text-sm">Belum ada riwayat pembayaran</p>
                </div>`;
            return;
        }

        let html = '<div class="space-y-3">';
        result.data.forEach(item => {
            const date = new Date(item.date).toLocaleDateString('id-ID', {
                day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
            });

            html += `
                <div class="flex items-center justify-between p-3 bg-slate-50 border border-slate-100 rounded-xl">
                    <div>
                        <p class="text-[10px] text-slate-400 uppercase font-bold tracking-wider">${date}</p>
                        <p class="font-bold text-slate-800">Rp ${parseFloat(item.amount).toLocaleString('id-ID')}</p>
                    </div>
                    ${item.image_path ? `
                        <a href="/${item.image_path}" target="_blank" class="h-10 w-10 rounded-lg overflow-hidden border border-slate-200">
                            <img src="/${item.image_path}" class="h-full w-full object-cover">
                        </a>
                    ` : '<span class="text-[9px] text-slate-300 italic">No image</span>'}
                </div>
            `;
        });
        html += '</div>';
        content.innerHTML = html;

    } catch (error) {
        content.innerHTML = `<p class="text-red-500 text-center py-4">Gagal memuat data.</p>`;
    }
}

window.closeModalHistory = function(type = 'in') {
    const suffix = type === 'out' ? '_out' : '_in';
    document.getElementById(`modalHistory${suffix}`).classList.add("hidden");
}

// =============================
// SEARCH CUSTOMER
// =============================
async function loadCustomers() {

    const select = document.getElementById('customerSelect');

    try {

        const res = await fetch('/report/get-customers');
        const data = await res.json();

        select.innerHTML = '<option value="">-- Semua Customer --</option>';

        data.forEach(c => {
            let cleanName = c.name
                .replace(/^\d+\|?/, '')
                .replace(/\|/g, '')
                .trim();

            const option = document.createElement('option');
            option.value = c.name;
            option.value = c.id;
            option.textContent = c.name;
            select.appendChild(option);
            option.textContent = cleanName;
        });

    } catch (err) {
        console.error('Load customer error:', err);
    }

}

function loadTahun() {
    const select = document.getElementById('tahunSelect');
    if (!select) return;

    const currentYear = new Date().getFullYear();

    for (let i = currentYear; i >= currentYear - 5; i--) {
        const option = document.createElement('option');
        option.value = i;
        option.textContent = i;
        select.appendChild(option);
    }
}

function initSearchCustomer() {

    const customer = document.getElementById('customerSelect');
    const bulan = document.getElementById('bulanSelect');
    const tahun = document.getElementById('tahunSelect');

    if (!customer) return;

    async function triggerSearch() {

        const customerId = customer.value;
        const bulanVal   = bulan.value;
        const tahunVal   = tahun.value;

        try {

            const res = await fetch(
                `/report/search-customer?customer_id=${customerId}&bulan=${bulanVal}&tahun=${tahunVal}`
            );

            const html = await res.text();

            document.getElementById('orderContainer').innerHTML = html;
           function removeDuplicateSelect(id) {
                const elements = document.querySelectorAll(`#${id}`);
                if (elements.length > 1) {
                    elements[1].closest('.relative').remove();
                }
            }

            // pakai
            removeDuplicateSelect('customerSelect');
            removeDuplicateSelect('bulanSelect');
            removeDuplicateSelect('tahunSelect');

        } catch (error) {
            console.error("Search error:", error);
        }
    }

    customer.addEventListener('change', triggerSearch);
    bulan.addEventListener('change', triggerSearch);
    tahun.addEventListener('change', triggerSearch);
}

// init
document.addEventListener('DOMContentLoaded', () => {
    loadCustomers();
    loadTahun();
    initSearchCustomer();
});

// =============================
// SEARCH CUSTOMER PROGRES OUT
// =============================

async function loadCustomersOut() {

    const select = document.getElementById('customerSelectOut');
    if (!select) return;

    try {

        const res = await fetch('/report/get-customers');
        const data = await res.json();

        select.innerHTML = '<option value="">-- Semua Customer --</option>';

        data.forEach(c => {

            let cleanName = c.name
                .replace(/^\d+\|?/, '')
                .replace(/\|/g, '')
                .trim();

            const option = document.createElement('option');
            option.value = c.id;
            option.textContent = cleanName;

            select.appendChild(option);
        });

    } catch (err) {
        console.error('Load customer OUT error:', err);
    }
}

function loadTahunOut() {
    const select = document.getElementById('tahunSelectOut');
    if (!select) return;

    const currentYear = new Date().getFullYear();

    for (let i = currentYear; i >= currentYear - 5; i--) {
        const option = document.createElement('option');
        option.value = i;
        option.textContent = i;
        select.appendChild(option);
    }
}

function initSearchCustomerOut() {

    const customer = document.getElementById('customerSelectOut');
    const bulan    = document.getElementById('bulanSelectOut');
    const tahun    = document.getElementById('tahunSelectOut');

    if (!customer) return;

    async function triggerSearch() {

        const customerId = customer.value;
        const bulanVal   = bulan?.value || '';
        const tahunVal   = tahun?.value || '';

        try {

            const res = await fetch(
                `/report/search-customer-out?customer_id=${customerId}&bulan=${bulanVal}&tahun=${tahunVal}`
            );

            const html = await res.text();

            document.getElementById('orderContainerOut').innerHTML = html;
            function removeDuplicateSelect(id) {
                    const elements = document.querySelectorAll(`#${id}`);
                    if (elements.length > 1) {
                        elements[1].parentElement.remove();
                    }
                }

            removeDuplicateSelect('customerSelectOut');
            removeDuplicateSelect('bulanSelectOut');
            removeDuplicateSelect('tahunSelectOut');

        } catch (error) {
            console.error("Search OUT error:", error);
        }
    }

    customer.addEventListener('change', triggerSearch);
    bulan?.addEventListener('change', triggerSearch);
    tahun?.addEventListener('change', triggerSearch);
}

// INIT KHUSUS OUT
document.addEventListener('DOMContentLoaded', () => {
    loadCustomersOut();
    loadTahunOut();
    initSearchCustomerOut();
});

window.finishOrder = async function(orderId, orderCode)
{
    const today = new Date().toISOString().split('T')[0];

    const result = await Swal.fire({
        title: 'Selesaikan Order',
        html: `
            <div class="text-left space-y-4">

                <div class="bg-slate-100 rounded-xl px-4 py-3 border border-slate-200">
                    <div class="text-xs text-slate-500 uppercase font-bold tracking-wider mb-1">
                        Kode Order
                    </div>

                    <div class="text-sm font-bold text-indigo-600">
                        ${orderCode}
                    </div>
                </div>

                <div>
                    <label class="block text-sm font-semibold mb-1">
                        Remark (Opsional)
                    </label>

                    <textarea
                        id="finish_remark"
                        class="swal2-textarea"
                        placeholder="Masukkan remark..."
                        style="margin:0; width:100%; height:90px;"
                    ></textarea>
                </div>

                <div>
                    <label class="block text-sm font-semibold mb-1">
                        Diskon
                    </label>

                    <input
                        type="number"
                        id="finish_diskon"
                        class="swal2-input"
                        placeholder="0"
                        value="0"
                        style="margin:0; width:100%;"
                    >
                </div>

                <div>
                    <label class="block text-sm font-semibold mb-1">
                        Finish Date
                    </label>

                    <input
                        type="date"
                        id="finish_date"
                        class="swal2-input"
                        value="${today}"
                        style="margin:0; width:100%;"
                    >
                </div>

            </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Ya, Selesaikan',
        cancelButtonText: 'Batal',
        confirmButtonColor: '#4f46e5',
        cancelButtonColor: '#9ca3af',
        focusConfirm: false,
        preConfirm: () => {

            return {
                remark: document.getElementById('finish_remark').value,
                diskon: document.getElementById('finish_diskon').value,
                finish_date: document.getElementById('finish_date').value
            };
        }
    });

    if (!result.isConfirmed) return;

    try {

        Swal.fire({
            title: 'Memproses...',
            text: 'Sedang menyelesaikan order',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading()
        });

        const response = await fetch(`/report/order/finish/${orderId}`, {
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': document
                    .querySelector('meta[name="csrf-token"]')
                    .getAttribute('content'),

                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },

            body: JSON.stringify({
                remark: result.value.remark,
                diskon: result.value.diskon,
                finish_date: result.value.finish_date
            })
        });

        const res = await response.json();

        Swal.close();

        if (res.success) {

            await Swal.fire({
                icon: 'success',
                title: 'Berhasil',
                text: res.message,
                confirmButtonColor: '#4f46e5'
            });

            location.reload();

        } else {

            Swal.fire({
                icon: 'error',
                title: 'Gagal',
                text: res.message || 'Gagal menyelesaikan order',
                confirmButtonColor: '#ef4444'
            });

        }

    } catch (error) {

        console.error(error);

        Swal.close();

        Swal.fire({
            icon: 'error',
            title: 'Terjadi Kesalahan',
            text: 'Server bermasalah',
            confirmButtonColor: '#ef4444'
        });

    }
}
